import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import moment from "moment";

export const exportGastosToExcel = (data, inmuebles, fileName = "gastos.xlsx") => {
    if (!data || data.length === 0) {
        alert("No hay datos para exportar");
        return;
    }

    const getInmuebleName = (id) => {
        const inmueble = inmuebles?.find(im => im.id === id);
        return inmueble ? inmueble.name : "Desconocido";
    };

    const exportData = data.map(g => ({
        Inmueble: getInmuebleName(g.propertieId),
        Gasto: g.name,
        Total: g.amount,
        IVA: g.iva,
        Subtotal: g.subtotal,
        Fecha: moment(g.createdAt).format("YYYY-MM-DD"),
        FormaPago: g.forma_pago,
        Titular: g?.titular || "NA",
        Comentarios: g.comments || "",
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);

    ws['!cols'] = [
        { wch: 25 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 10 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 40 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Gastos");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, fileName);
};
